import React from "react";
import { createRoot } from "react-dom/client";
import axios from "axios";

import {
    FacebookIcon,
    FacebookShareButton,
    TwitterIcon,
    TwitterShareButton,
    TelegramIcon,
    TelegramShareButton,
    VKIcon,
    VKShareButton,
    OKIcon,
    OKShareButton,
    EmailIcon,
    EmailShareButton,
    PinterestIcon,
    PinterestShareButton,
    RedditIcon,
    RedditShareButton,
    TumblrIcon,
    TumblrShareButton,
} from "react-share";

const ShareButtons = ({ socials, appId }) => {
    const handleClick = (platform) => {
        // Отправляем запрос на сервер для записи клика
        axios
            .post("/setSocialClicks", {
                platform: platform,
                appId: appId,
            })
            .then((response) => {
                console.log("Click recorded:", response.data);
            })
            .catch((error) => {
                console.error("Error recording click:", error);
            });
    };

    const shareUrl = window.location.href;
    const shareImg = window.location.href + "/img/touch-icon-iphone.png";
    const arrSocials = socials.split("|");

    const getUTMUrl = (baseURL, platform) => {
        const url = new URL(baseURL);
        url.searchParams.append("utm_source", platform);
        url.searchParams.append("utm_medium", "social");
        url.searchParams.append("utm_campaign", "share_buttons");
        return url.toString();
    };

    return (
        <div className="flex mt-1">
            {arrSocials.includes("vk") && (
                <div className="share-button-wrapper" title="VK">
                    <VKShareButton
                        resetButtonStyle={false}
                        className="share-button"
                        url={getUTMUrl(shareUrl, "vk")}
                        onClick={() => handleClick("vk")}
                    >
                        <VKIcon
                            className="share-icon w-9 h-9"
                            bgStyle={{ fill: "#4c75a3" }}
                            iconFillColor={"#ffffff"}
                            size={32}
                            round={true}
                        />
                    </VKShareButton>
                </div>
            )}
            {arrSocials.includes("ok") && (
                <div className="share-button-wrapper" title="OK">
                    <OKShareButton
                        resetButtonStyle={false}
                        className="share-button"
                        url={getUTMUrl(shareUrl, "ok")}
                        onClick={() => handleClick("ok")}
                    >
                        <OKIcon
                            className="share-icon w-9 h-9"
                            bgStyle={{ fill: "#ed812b" }}
                            iconFillColor={"#ffffff"}
                            size={32}
                            round={true}
                        />
                    </OKShareButton>
                </div>
            )}
            {arrSocials.includes("fb") && (
                <div className="share-button-wrapper" title="Facebook">
                    <FacebookShareButton
                        resetButtonStyle={false}
                        className="share-button"
                        url={getUTMUrl(shareUrl, "fb")}
                        onClick={() => handleClick("fb")}
                    >
                        <FacebookIcon
                            className="share-icon w-9 h-9"
                            bgStyle={{ fill: "#3b5998" }}
                            iconFillColor={"#ffffff"}
                            size={32}
                            round={true}
                        />
                    </FacebookShareButton>
                </div>
            )}
            {arrSocials.includes("tw") && (
                <div className="share-button-wrapper" title="Twitter">
                    <TwitterShareButton
                        resetButtonStyle={false}
                        className="share-button"
                        url={getUTMUrl(shareUrl, "tw")}
                        onClick={() => handleClick("tw")}
                    >
                        <TwitterIcon
                            className="share-icon w-9 h-9"
                            bgStyle={{ fill: "#1da1f2" }}
                            iconFillColor={"#ffffff"}
                            size={32}
                            round={true}
                        />
                    </TwitterShareButton>
                </div>
            )}
            {arrSocials.includes("tg") && (
                <div className="share-button-wrapper" title="Telegram">
                    <TelegramShareButton
                        resetButtonStyle={false}
                        className="share-button"
                        url={getUTMUrl(shareUrl, "tg")}
                        onClick={() => handleClick("tg")}
                    >
                        <TelegramIcon
                            className="share-icon w-9 h-9"
                            bgStyle={{ fill: "#0088cc" }}
                            iconFillColor={"#ffffff"}
                            size={32}
                            round={true}
                        />
                    </TelegramShareButton>
                </div>
            )}
            {arrSocials.includes("pt") && (
                <div className="share-button-wrapper" title="Pinterest">
                    <PinterestShareButton
                        resetButtonStyle={false}
                        className="share-button"
                        url={getUTMUrl(shareUrl, "pt")}
                        media={shareImg}
                        onClick={() => handleClick("pt")}
                    >
                        <PinterestIcon
                            className="share-icon w-9 h-9"
                            bgStyle={{ fill: "#bd081c" }}
                            iconFillColor={"#ffffff"}
                            size={32}
                            round={true}
                        />
                    </PinterestShareButton>
                </div>
            )}
            {arrSocials.includes("rd") && (
                <div className="share-button-wrapper" title="Reddit">
                    <RedditShareButton
                        resetButtonStyle={false}
                        className="share-button"
                        url={getUTMUrl(shareUrl, "rd")}
                        onClick={() => handleClick("rd")}
                    >
                        <RedditIcon
                            className="share-icon w-9 h-9"
                            bgStyle={{ fill: "#ff4500" }}
                            iconFillColor={"#ffffff"}
                            size={32}
                            round={true}
                        />
                    </RedditShareButton>
                </div>
            )}
            {arrSocials.includes("tb") && (
                <div className="share-button-wrapper" title="Tumblr">
                    <TumblrShareButton
                        resetButtonStyle={false}
                        className="share-button"
                        url={getUTMUrl(shareUrl, "tb")}
                        onClick={() => handleClick("tb")}
                    >
                        <TumblrIcon
                            className="share-icon w-9 h-9"
                            bgStyle={{ fill: "#35465c" }}
                            iconFillColor={"#ffffff"}
                            size={32}
                            round={true}
                        />
                    </TumblrShareButton>
                </div>
            )}
            {arrSocials.includes("em") && (
                <div className="share-button-wrapper" title="Email">
                    <EmailShareButton
                        resetButtonStyle={false}
                        className="share-button"
                        url={getUTMUrl(shareUrl, "em")}
                        onClick={() => handleClick("em")}
                    >
                        <EmailIcon
                            className="share-icon w-9 h-9"
                            bgStyle={{ fill: "#7f7f7f" }}
                            iconFillColor={"#ffffff"}
                            size={32}
                            round={true}
                        />
                    </EmailShareButton>
                </div>
            )}
        </div>
    );
};

if (document.getElementById("share-buttons")) {
    const container = document.getElementById("share-buttons");
    const root = createRoot(container);
    root.render(
        <ShareButtons
            socials={container.getAttribute("socials")}
            appId={container.getAttribute("appId")}
        />
    );
}
